<template>
    <v-menu
        transition="slide-y-transition"
        min-width="240"
        offset-y
        :nudge-right="20"
        v-model="showPro"
    >
        <v-btn slot="activator" icon>
            <v-icon class="white--text">person</v-icon>
        </v-btn>
        <v-list class="fs14i">
                <v-list-tile :to="{path: '/profile'}" avatar>
                    <v-list-tile-avatar>
                        <v-avatar v-if="$store.getters.getProfile.avatar"
                            :size="40" 
                            class="custom-avatar"
                            v-ripple
                            :style="{'background-image': 'url(' + $store.getters.getProfile.avatar + ')'}">
                        </v-avatar>
                        <v-icon x-large v-else>account_circle</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title class="fs14i fw500">{{ $store.getters.getProfile.name}}</v-list-tile-title>
                        <v-list-tile-sub-title class="fs14i fw500">{{ $store.getters.getProfile.email}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            <v-divider></v-divider>

            <v-list-tile @click="$store.dispatch('AUTH_LOGOUT')">
                <v-list-tile-content>
                    <v-list-tile-title class="fs14i">Logout</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="red">exit_to_app</v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>
<script>
export default {
	name: 'profile-menu',
	data() {
		return {
			showPro: false
		}
	}
}
</script>
